module.exports = __webpack_public_path__ + "img/profession1.0a2af59f.png";